"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _index = _interopRequireDefault(require("@/components/Store/RangePick/index.vue"));
var _index2 = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * info:
 * step6 访店记录 page
 */
/** components */
/** statics */
var _default2 = exports.default = {
  components: {
    RangePick: _index.default
  },
  props: {
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    },
    // 计划任务详情
    ptInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 表单信息，所有步骤用一个表单
    form: {
      type: Object,
      default: function _default() {
        return {
          visitParam: {
            recordFeedback: {}
          }
        };
      }
    },
    // 表单规则
    rules: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 当前页面用到的 所有下拉options配置
    /**
     * optConfig.visitPurposeOptions: [], // 拜访目的select
     * optConfig.VRCheckListOptions: [] // 拜访报告的checklist
     */
    optConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isBailianFlag: {
      type: Boolean,
      default: false
    },
    feedbackCheckList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      uploadParams: {
        // businessKey: retailorStoreInfoPk, // 不知道编辑要不要这个字段，后续扩展编辑的人去问问
        resourceConfigFlag: 'sfe_store'
      },
      // 上传图片配置
      checkKeys: [],
      // 其他选项 选中的项目
      YorNOptions: [{
        'name': this.$t('menuList.form.yes'),
        'code': 'Y'
      }, {
        'name': this.$t('menuList.form.no'),
        'code': 'N'
      }],
      urgentDeliveryTimeVal: '',
      regularDeliveryTimeVal: '',
      evaluateRate: 0,
      goodContentList: [],
      badContentList: [],
      otherContentStr: '',
      isOtherContentSelected: false
    };
  },
  computed: {
    // 是否可编辑
    canEdit: function canEdit() {
      return this.mode === 'edit';
    },
    titleTxt: function titleTxt() {
      return "".concat(this.mode === 'edit' ? this.$t('common.create') : '').concat(this.$t('storeVisitReport.step.visitorRecord'));
    }
  },
  watch: {
    /**
     * 因为后端要求传递的数据格式问题，所以传參需要在组件内自行处理
     */
    'form.visitParam.checkList': {
      immediate: true,
      deep: true,
      handler: function handler(val, oldVal) {
        var arr = (val || []).filter(function (i) {
          return i.checkListItemVal === 'Y';
        }).map(function (i) {
          return i.checkListItem;
        });
        var oldArr = (oldVal || []).filter(function (i) {
          return i.checkListItemVal === 'Y';
        }).map(function (i) {
          return i.checkListItem;
        });
        if (JSON.stringify(arr) !== JSON.stringify(oldArr)) {
          this.checkKeys = arr;
        }
      }
    }
  },
  mounted: function mounted() {
    this.initData();
  },
  methods: {
    // 初始化报告详情数据
    initData: function initData() {
      // BaiLian门店转化时初始化这部分数据
      if (this.isBailianFlag) {
        var recordFeedbackObj = this.form.visitParam.recordFeedback || {};
        this.form.visitParam.recordFeedback.acceptTerms = recordFeedbackObj.acceptTerms;
        this.form.visitParam.recordFeedback.willingToRtmOrder = recordFeedbackObj.willingToRtmOrder;
        // 评价部分数据
        this.evaluateRate = recordFeedbackObj.evaluateRate || 0;
        this.goodContentList = recordFeedbackObj.goodContent || [];
        this.badContentList = recordFeedbackObj.badContent || [];
        this.isOtherContentSelected = (recordFeedbackObj.otherContent || []).length > 0;
        this.otherContentStr = this.isOtherContentSelected ? recordFeedbackObj.otherContent[0] : '';
        // 紧急订单时效
        // const urgentDeliveryTime = recordFeedbackObj['urgentDeliveryTime']
        var urgentDeliveryStartTime = recordFeedbackObj['urgentDeliveryStartTime'];
        var urgentDeliveryEndTime = recordFeedbackObj['urgentDeliveryEndTime'];
        this.urgentDeliveryTimeVal = "".concat(urgentDeliveryStartTime || 'null', ",").concat(urgentDeliveryEndTime || 'null');
        if (this.urgentDeliveryTimeVal === 'null,null') {
          this.urgentDeliveryTimeVal = '';
        }
        // 没有值时默认第一个选项
        // if (urgentDeliveryTime === null && this.optConfig.urgentDeliveryTimeOptions.length) {
        //   this.form.visitParam.recordFeedback.urgentDeliveryTime = this.optConfig.urgentDeliveryTimeOptions[0]['code']
        //   this.urgentDeliveryTimeVal = this.optConfig.urgentDeliveryTimeOptions[0]['code'] || 'null,null'
        //   this.form.visitParam.recordFeedback.urgentDeliveryStartTime = this.urgentDeliveryTimeVal.split(',')[0] === 'null' ? null : this.urgentDeliveryTimeVal.split(',')[0]
        //   this.form.visitParam.recordFeedback.urgentDeliveryEndTime = this.urgentDeliveryTimeVal.split(',')[1] === 'null' ? null : this.urgentDeliveryTimeVal.split(',')[1]
        // }
        // 常规订单时效
        // const regularDeliveryTime = recordFeedbackObj['regularDeliveryTime']
        var regularDeliveryStartTime = recordFeedbackObj['regularDeliveryStartTime'];
        var regularDeliveryEndTime = recordFeedbackObj['regularDeliveryEndTime'];
        this.regularDeliveryTimeVal = "".concat(regularDeliveryStartTime || 'null', ",").concat(regularDeliveryEndTime || 'null');
        if (this.regularDeliveryTimeVal === 'null,null') {
          this.regularDeliveryTimeVal = '';
        }
        // 没有值时默认第一个选项
        // if (regularDeliveryTime === null && this.optConfig.regularDeliveryTimeOptions.length) {
        //   this.form.visitParam.recordFeedback.regularDeliveryTime = this.optConfig.regularDeliveryTimeOptions[0]['code']
        //   this.regularDeliveryTimeVal = this.optConfig.regularDeliveryTimeOptions[0]['code'] || 'null,null'
        //   this.form.visitParam.recordFeedback.regularDeliveryStartTime = this.regularDeliveryTimeVal.split(',')[0] === 'null' ? null : this.regularDeliveryTimeVal.split(',')[0]
        //   this.form.visitParam.recordFeedback.regularDeliveryEndTime = this.regularDeliveryTimeVal.split(',')[1] === 'null' ? null : this.regularDeliveryTimeVal.split(',')[1]
        // }
      }
    },
    // 格式化Voptions数据
    formatVoptions: function formatVoptions(key) {
      return (0, _index2.formatKeyValue)(key, this.optConfig.visitPurposeOptions);
    },
    clearForm: function clearForm() {
      Object.assign(this.$data, this.$options.data.call(this));
      this.$refs['dataForm'].resetFields();
      // 为BaiLian门店转化时
      if (this.isBailianFlag) {
        this.$refs['dataForm2'].resetFields();
      }
    },
    // 上传图片
    handleUploadPhoto: function handleUploadPhoto(file, fileList) {
      console.log('上传图片', file, fileList);
    },
    // checklist变更
    onCheckListChange: function onCheckListChange(keys) {
      var _this$form$visitParam;
      console.log(333, keys);
      var formatList = this.optConfig.VRCheckListOptions.map(function (i, index) {
        return {
          checkListItem: i.code,
          checkListItemVal: keys.indexOf(i.code) >= 0 ? 'Y' : 'N',
          sn: index + 1
        };
      });
      var checkList = this.form.visitParam.checkList || [];
      this.form.visitParam.checkList && (_this$form$visitParam = this.form.visitParam.checkList).splice.apply(_this$form$visitParam, [0, checkList.length].concat((0, _toConsumableArray2.default)(formatList)));
    },
    onCheckListChange2: function onCheckListChange2(keys) {
      console.log(333, keys);
      this.form.visitParam.dynamicDataList = keys;
      // const formatList = this.optConfig.VRCheckListOptions.map((i, index) => {
      //   return {
      //     checkListItem: i.code,
      //     checkListItemVal: keys.indexOf(i.code) >= 0 ? 'Y' : 'N',
      //     sn: index + 1
      //   }
      // })
      // const checkList = this.form.visitParam.checkList || []
      // this.form.visitParam.checkList && this.form.visitParam.checkList.splice(0, checkList.length, ...formatList)
    },
    // 保存草稿
    onSaveDraft: function onSaveDraft() {
      console.log('保存草稿');
      this.$emit('draft');
    },
    // 保存 提交
    onSave: function onSave() {
      var _this = this;
      this.$refs['dataForm'].clearValidate();
      // 为BaiLian门店转化时
      if (this.isBailianFlag) {
        this.$refs['dataForm2'].clearValidate();
      }
      // 表单1
      var form1 = new Promise(function (resolve, reject) {
        _this.$refs['dataForm'].validate(function (valid) {
          if (valid) {
            resolve();
          } else {
            reject();
          }
        });
      });
      // 表单2
      var form2 = new Promise(function (resolve, reject) {
        // 为BaiLian门店转化时
        if (_this.isBailianFlag) {
          _this.$refs['dataForm2'].validate(function (valid) {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        } else {
          resolve();
        }
      });
      // 表单部分验证通过时
      Promise.all([form1, form2]).then(function () {
        // 至少上传一张图片
        var res = _this.form.visitParam.photos && _this.form.visitParam.photos.find(function (item) {
          return item.url;
        });
        if (!res) {
          _this.$message.error(_this.$t('storeVisitReport.errMsg.photos'));
          return;
        }
        // 检查表至少勾选一项
        if (!_this.checkKeys.length) {
          _this.$message.error(_this.$t('storeVisitReport.errMsg.checkList'));
          return;
        }
        if (_this.form.visitParam.dynamicDataList.indexOf('其他拜访任务') > -1 && !_this.form.visitParam.otherTaskDescription) {
          _this.$message.error(_this.$t('storeVisitReport.errMsg.otherTaskDescription'));
          return;
        }
        // 为BaiLian门店转化时需要给门店评分
        if (_this.isBailianFlag && !_this.evaluateRate) {
          _this.$message.error(_this.$t('storeVisitReport.errMsg.evaluateRate'));
          return;
        }
        // 为BaiLian门店转化时需要至少有一个评价
        if (_this.isBailianFlag && !_this.badContentList.length && !_this.goodContentList.length && !_this.otherContentStr) {
          _this.$message.error(_this.$t('storeVisitReport.errMsg.contentList'));
          return;
        }
        // 为BaiLian门店转化时其他评价勾选时内容不能为空
        if (_this.isBailianFlag && _this.isOtherContentSelected && !_this.otherContentStr) {
          _this.$message.error(_this.$t('storeVisitReport.errMsg.otherContentList'));
          return;
        }
        console.log('校验通过');
        _this.$emit('save');
      }).catch(function (errMsg) {
        _this.$message.error(_this.$t('errorValid.formError'));
      });
    },
    // 紧急订单选择后逻辑
    handleUrgentDeliveryTime: function handleUrgentDeliveryTime(val) {
      var selectItem = this.optConfig.urgentDeliveryTimeOptions.find(function (item) {
        return item['code'] === val;
      });
      if (selectItem) {
        this.form.visitParam.recordFeedback.urgentDeliveryTime = selectItem['code'];
        this.form.visitParam.recordFeedback.urgentDeliveryStartTime = selectItem['code'].split(',')[0] === 'null' ? null : selectItem['code'].split(',')[0];
        this.form.visitParam.recordFeedback.urgentDeliveryEndTime = selectItem['code'].split(',')[1] === 'null' ? null : selectItem['code'].split(',')[1];
      }
    },
    // 常规订单选择后逻辑
    handleRegularDeliveryTime: function handleRegularDeliveryTime(val) {
      var selectItem = this.optConfig.regularDeliveryTimeOptions.find(function (item) {
        return item['code'] === val;
      });
      if (selectItem) {
        this.form.visitParam.recordFeedback.regularDeliveryTime = selectItem['code'];
        this.form.visitParam.recordFeedback.regularDeliveryStartTime = selectItem['code'].split(',')[0] === 'null' ? null : selectItem['code'].split(',')[0];
        this.form.visitParam.recordFeedback.regularDeliveryEndTime = selectItem['code'].split(',')[1] === 'null' ? null : selectItem['code'].split(',')[1];
      }
    },
    // 评分后逻辑
    onEvaluate: function onEvaluate(val) {
      this.form.visitParam.recordFeedback.evaluateRate = val;
    },
    // 正面评价选择后逻辑
    onGoodContentChange: function onGoodContentChange(val) {
      this.form.visitParam.recordFeedback.goodContent = val;
    },
    // 反面评价选择后逻辑
    onBadContentChange: function onBadContentChange(val) {
      // 存在其他评价选项时值为null需要在form中过滤掉，badContentList需要保留以显示勾选状态
      this.form.visitParam.recordFeedback.badContent = val.filter(function (item) {
        return !!item;
      });
    },
    // 其他评价勾选时逻辑
    handleOtherContentSelected: function handleOtherContentSelected(val) {
      this.isOtherContentSelected = val;
      if (val) {
        this.form.visitParam.recordFeedback.otherContent = [''];
        this.otherContentStr = '';
      } else {
        this.form.visitParam.recordFeedback.otherContent = [];
        this.otherContentStr = '';
      }
    },
    // 其他评价输入后逻辑
    handleotherContent: function handleotherContent(val) {
      this.form.visitParam.recordFeedback.otherContent = [val];
    }
  }
};